module.exports = __webpack_public_path__ + "img/logo_moban.58127742.jpg";